module.exports = __webpack_public_path__ + "img/about2.1b27bac2.jpg";